export default __webpack_public_path__ + "static/media/yarnstasher.94116e6c.png";